export enum LinkIcon {
  GITHUB = 'github',
  LEGAL = 'legal',
}
